import React from 'react';
import { Container } from 'components/basics';
import styled from 'styled-components';
import BlockText from './BlockText';
import { Grid } from '@material-ui/core';
import Content from 'components/basics/Content';
import SubIntroBackground from 'components/pages/Solution/Marketing/SubIntroBackground';
import BlockImage from 'components/pages/Solution/Marketing/BlockImage';
import BlockBook from 'components/pages/Solution/Marketing/BlockBook';
import BlockObjectives from 'components/pages/Solution/Marketing/BlockObjectives';
import { breakpoint } from 'utils/mediaQueries';

const GridSubIntro = styled(Grid)`
  ${Content};
  max-width: 1080px;
  padding: 0 2rem;
  padding-bottom: 10rem;
  ${breakpoint.down('lg')`
  padding:1rem 2rem;`};
`;
const GridBook = styled(Grid)`
  position: relative;
  width: 100%;
  ${breakpoint.down('md')`
  background: none;`};
`;
const GridObjectives = styled(Grid)`
  ${breakpoint.down('md')`
  padding-top: 2rem`};
`;
const StyledContainer = styled(Container)`
  padding-top: 2rem;
  ${breakpoint.down('md')`
  padding-top: 0;
  `}
`;
class SubIntroBlocks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 200,
      heightHeader: 0,
      heightIntro: 0,
      heightTitleIntro: 0,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }
  updateDimensions() {
    const heightNav = document.getElementById('headerNav');
    const heightIntro = document.getElementById('introBlock');
    const heightTitleIntro = document.getElementById('titleIntroBlock');
    this.setState({
      width: window.innerWidth,
      heightHeader: heightNav && heightNav.offsetHeight,
      heightIntro: heightIntro && heightIntro.offsetHeight,
      heightTitleIntro: heightTitleIntro && heightTitleIntro.offsetHeight,
    });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const heightNav = document.getElementById('headerNav');
    if (heightNav && prevState.heightHeader !== this.state.heightHeader) {
      this.updateDimensions();
    }
  }
  render() {
    const widthWindow = this.state.width;
    const heightTitle =
      this.state.heightTitleIntro + this.state.heightHeader + 96;
    const heightBackground =
      this.state.heightHeader + this.state.heightIntro + 216;
    return (
      <StyledContainer>
        <GridSubIntro container spacing={24} id="introBlock">
          <BlockText markdownContent={this.props.data.markdownContent} />
        </GridSubIntro>
        <GridBook container justify="center">
          <BlockBook body={this.props.data.body} lang={this.props.lang} />
          <BlockImage images={this.props.data.images} />
        </GridBook>
        <GridObjectives container justify="center">
          <BlockObjectives
            images={this.props.data.imgObjectives}
            data={this.props.data.markdownObjectives}
          />
        </GridObjectives>
        <SubIntroBackground
          heightBackground={heightBackground}
          widthWindow={widthWindow}
          heightTitle={heightTitle}
        />
      </StyledContainer>
    );
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
}

export default SubIntroBlocks;
